import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { Reveal, CTAButton } from "./ui";
export function Guarantee() {
  return <section id="garantia" className="w-full bg-[var(--calm-green)]/40 px-4 py-10 sm:px-8 sm:py-24" data-id="element-104" data-mp="1o3dlq91ns7pk">
      <Reveal className="mx-auto max-w-3xl" data-id="element-105" data-mp="222n0r5e4ovry">
        <div className="flex flex-col items-center gap-5 rounded-3xl border border-[#dceee3] bg-white p-5 text-center shadow-[0_24px_60px_-34px_rgba(31,51,69,0.5)] sm:flex-row sm:gap-8 sm:rounded-[2rem] sm:p-12 sm:text-left" data-id="element-106" data-mp="1x3tnne2r76sb">
          <div className="flex-none" data-id="element-107" data-mp="14gph34o0ikef">
            <div className="relative flex h-24 w-24 items-center justify-center rounded-full border-4 border-dashed border-[var(--accent-green)]/40 bg-[var(--calm-green)] sm:h-32 sm:w-32" data-id="element-108" data-mp="14dl53l4b2kd7">
              <ShieldCheckIcon className="h-11 w-11 text-[var(--accent-green)] sm:h-14 sm:w-14" aria-hidden data-id="element-109" data-mp="1ebr2bpf632bq" />
              <span className="absolute -bottom-2 rounded-full bg-[var(--accent-green)] px-3 py-1 text-xs font-bold text-white shadow" data-id="element-110" data-mp="qlwr1cahxltl">
                7 días
              </span>
            </div>
          </div>
          <div data-id="element-111" data-mp="tymgy5jsxixn">
            <h2 className="font-serif-display text-2xl font-semibold text-[var(--ink)] sm:text-3xl" data-id="element-112" data-mp="ty2ymnq8osj3">
              Probalo durante 7 días.
            </h2>
            <p className="mt-4 text-[var(--muted)]" data-id="element-113" data-mp="yq4gcp66fbgi">
              Abrí todos los tomos. Revisá todo el contenido. Si sentís que no
              era lo que esperabas… te devolvemos el dinero.{" "}
              <span className="font-semibold text-[var(--ink)]" data-id="element-114" data-mp="62i7p2i3dgms">
                Sin complicaciones.
              </span>
            </p>
            <div className="mt-5 sm:mt-6" data-id="element-115" data-mp="f1lnnxlypfx2">
              <CTAButton data-id="element-116" data-mp="ezsh0ibcmvp2">Quiero probarlo sin riesgo</CTAButton>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}